import { render, staticRenderFns } from "./TheSimpsons.vue?vue&type=template&id=aa9c84ec&scoped=true&"
import script from "./TheSimpsons.vue?vue&type=script&lang=js&"
export * from "./TheSimpsons.vue?vue&type=script&lang=js&"
import style0 from "./TheSimpsons.vue?vue&type=style&index=0&id=aa9c84ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9c84ec",
  null
  
)

export default component.exports